import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import usePageFetcher from "../../repository/usePageFetcher";
import Loader from "../../shared/components/loader";

import "./style.css";

const Articles = () => {
  const { isLoading, data } = usePageFetcher("image");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [image, setImage] = useState(null);

  useEffect(() => {
    if (data?.length) {
      setImage(data[0]?.img);
    }
  }, [data]);

  return (
    <div className="article_wrapper">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="content_wrapper article_container">
          <a
            href="https://online.anyflip.com/mtjjn/keja/mobile/index.html"
            className="party_newspaper"
            style={{
              "--background-image": image ? `url(${image})` : "none",
            }}
            target="_blank"
            rel="noreferrer"
          >
            <p className="article_title">{t("PARTIYA GAZETASI")}</p>
          </a>
          <div onClick={() => navigate("/articles")} className="party_articles">
            <p className="article_title">{t("MAQOLALAR")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Articles;
